import React, { ForwardedRef, forwardRef } from 'react';
import classNames from 'classnames';

import { InputRoundedSC, InputLinedSC } from './input.styled';

export const VARIATION_ROUND = 'round';
export const VARIATION_LINED = 'lined';

export type TInputVariation = typeof VARIATION_LINED | typeof VARIATION_ROUND;

type TInputProps = {
  variation: TInputVariation;
  prefix?: React.ReactNode;
  suffix?: React.ReactNode;
  hasError?: boolean;
  className?: string;
} & React.InputHTMLAttributes<HTMLInputElement>;

const Input = forwardRef(function Input(
  { variation, prefix, suffix, hasError = false, className, ...rest }: TInputProps,
  ref: ForwardedRef<HTMLInputElement>,
) {
  const cNames = classNames(className, { 'has-error': hasError });
  const innerBody = (
    <>
      {prefix && <span className="prefix">{prefix}</span>}
      <input ref={ref} {...rest} />
      {suffix && <span className="suffix">{suffix}</span>}
    </>
  );

  if (variation === VARIATION_LINED) {
    return <InputLinedSC className={cNames}>{innerBody}</InputLinedSC>;
  }

  return <InputRoundedSC className={cNames}>{innerBody}</InputRoundedSC>;
});

export default Input;
